import React, { memo, useMemo } from 'react'
import parser from 'react-html-parser'
import { useSelector } from 'react-redux'
import { getApplicationModelName } from '../../../common/fns'
import { convertUserInputToDisplayFormat } from '../../../common/tableHeaders'
import useStaticData from '../../../common/useStaticData'
import { RelatedImages } from '../../../components'
import TableView from '../../../components/TableView'

const DowelingPrintable = () => {
  const { input, output } = useSelector((state) => state.calculation)
  const staticData = useSelector((state) => state.staticData)

  const { adhesiveAnchor, insertType, insertDiameter } = input
  const { subAppList, dowelingOptions } = staticData

  const {
    getModels,
    getProductImage,
    getProductImages,
    getProductInfo,
    getProductOptions,
    getInsertDiameterOptions,
  } = useStaticData(staticData)

  const getJobColumns = (models, jobs) => {
    const dynamicColumns = models.reduce((result, item) => {
      const temp = {
        id: item.model,
        Header: parser(getApplicationModelName(item)),
        accessor: (d) => {
          return d[item.model] && d[item.model].toFixed(2)
        },
        Footer: () => {
          const x = jobs.reduce((total, entry) => total + entry[item.model], 0)
          return x.toFixed(2)
        },
      }
      result.push(temp)
      return result
    }, [])

    const jobColumns = [
      {
        id: 'job',
        Header: 'Job',
        accessor: 'jobName',
        Footer: 'Total',
      },
    ]
      .concat(dynamicColumns)
      .concat([
        {
          Header: 'User Inputs',
          accessor: (d) => {
            return convertUserInputToDisplayFormat(d.userInputs)
          },
          Cell: (row) => <div className="prettyPrint">{parser(row.cell.value)}</div>,
          Footer: '',
        },
      ])

    return jobColumns
  }

  const insertDiameterOptions = useMemo(() => getInsertDiameterOptions(insertType), [insertType])
  const adhesiveAnchorOptions = useMemo(
    () => getProductOptions(insertType, insertDiameter),
    [insertType, insertDiameter],
  )

  // const subAppItem = subAppList.find(p => p.value === input.subApp);
  // const insertTypeItem = dowelingOptions['insertType'].find(p => p.value === insertType)
  const models = getModels(adhesiveAnchor)
  const jobColumns = getJobColumns(models, output.jobs)
  const productInfo = getProductInfo(adhesiveAnchor)
  const modelImages = getProductImages(models.map((item) => item.model))
  const relatedImageItems = [insertType, 'Drill Bits', 'Accessories'].concat(
    productInfo.resinType === 'Epoxy'
      ? ['EpoxyMixingNozzles', 'EpoxyDispensingTools']
      : ['AcrylicMixingNozzles', 'AcrylicDispensingTools'],
  )
  const relatedImages = getProductImages(relatedImageItems)

  const inputColumns = [
    {
      Header: 'Condition',
      accessor: (d) => {
        return subAppList.find((p) => p.value === d.subApp).text
      },
    },
    {
      Header: 'Insert Type',
      accessor: (d) => {
        return dowelingOptions['insertType'].find((p) => p.value === d.insertType).text
      },
    },
    {
      Header: `Insert Diameter (${insertType})`,
      accessor: (d) => {
        return insertDiameterOptions.find((p) => p.value === d.insertDiameter).text
      },
    },
    {
      Header: 'Adhesive Anchor',
      accessor: (d) => {
        const text = adhesiveAnchorOptions.find((p) => p.value === d.adhesiveAnchor).text
        return d.adhesiveAnchor + ' ' + text
      },
    },
  ]

  return (
    <div>
      {input && (
        <section>
          <h2>Input</h2>

          {/*
        <section>
          <h3>Condition</h3>
          <div className="products-illustration">
            {subAppItem && <figure>
              <img src={subAppItem.imgSrc} alt={subAppItem.text} />
              <figcaption>{subAppItem.text}</figcaption>
            </figure>}

            {insertTypeItem && <figure>
              <img src={insertTypeItem.imgSrc} alt={insertTypeItem.text} />
              <figcaption>{insertTypeItem.text}</figcaption>
            </figure>}
          </div>
        </section>
        */}

          <TableView
            title={'Condition, Insert, Adhesive Anchor'}
            columns={inputColumns}
            data={[input]}
          />
        </section>
      )}

      {output.jobs && output.jobs.length > 1 && <div className="page-break" />}

      {output.jobs && output.jobs.length > 0 && (
        <section>
          <h2>Output</h2>

          <TableView
            title={'Job Tally'}
            columns={jobColumns}
            data={output.jobs}
            showFooter={true}
          />

          <div className="page-break" />

          <section>
            <a
              className="adhesiveMainProductLink"
              href={getProductImage(adhesiveAnchor).productUrl}
              target="_blank"
            >
              {adhesiveAnchor}
              &nbsp;<span className="productSummary">{productInfo.shortDesc}</span>
            </a>

            <div>
              {modelImages.map((item, index) => (
                <div className="adhesiveProduct" key={index + 1}>
                  <img src={item.imageUrl} alt={item.alt} />
                  <div className="adhesiveProduct__name">{item.name}</div>
                  <div className="adhesiveProduct__size">{item.productSize}</div>
                </div>
              ))}
              <p>{parser(productInfo.blurb)}</p>
            </div>
          </section>

          <section>
            <h3>Related Products</h3>
            <RelatedImages relatedImages={relatedImages} />
          </section>
        </section>
      )}
    </div>
  )
}

export default memo(DowelingPrintable)
